import React from "react";
import RichText from "@/components/legal/RichText";
import { MapConsentStatus } from "@/components/MapConsent";

export const LegalSections = ({ sections, page }) => (
  <div>
    {sections.map((s) => (
      <section key={s.id} id={s.id} data-testid={`${page}-section-${s.id}`}
        className="grid md:grid-cols-[240px_1fr] gap-2 md:gap-10 py-7 border-t border-line scroll-mt-28">
        <h2 className="font-display font-bold text-base text-ink">{s.title}</h2>
        <div className="space-y-3">
          {s.paragraphs.map((p) => <p key={p.slice(0, 40)} className="text-sm text-dim leading-relaxed"><RichText text={p} /></p>)}
          {s.action === "maps" && <MapConsentStatus />}
        </div>
      </section>
    ))}
  </div>
);

export default LegalSections;
